import React from 'react'
import FuboFreeTemplate from 'src/components/template/fubofree'
import USTemplateDefault from 'src/components/template/us'
import { usPlanData } from 'src/constants/planData/usPlanData'
import { PlanTypes } from 'src/constants/standaloneData'
import { useIsRSNAvailable } from 'src/modules/hooks/useIsRSNAvailable'

export default (props) => {
  const { isAvailable } = useIsRSNAvailable(PlanTypes.MARQUEE)

  const commonProps = {
    location: props.location,
    lang: 'en',
    market: 'us',
    title: 'Watch Marquee Sports Network',
    subtitle: 'STREAM THE CUBS, SKY AND RED STARS WITHOUT CABLE',
    additionalFAQs: additionalFAQs,
    video: 'https://assets-imgx.fubo.tv/marketing/lp/videos/compressed/Marquee_LP_10s_16x9.mp4',
    videoMobile: 'https://assets-imgx.fubo.tv/marketing/lp/videos/mobile/Marquee_LP_10s_1x1.mp4',
    customNetworks: ['marquee'],
  }

  return isAvailable ? (
    <FuboFreeTemplate
      {...commonProps}
      hasPlanCards={isAvailable}
      plans={[usPlanData.marquee_monthly, usPlanData.pro_standalone_monthly]}
      plansSharedData={{
        teams: usPlanData.marquee_monthly.teams,
      }}
    />
  ) : (
    <USTemplateDefault {...commonProps} />
  )
}

const additionalFAQs = [
  {
    question: 'How can I watch the Chicago Cubs with Fubo?',
    answer:
      'You can watch the Chicago Cubs on Marquee Sports Network with Fubo. This channel provides live coverage of Cubs games, analysis and more throughout the MLB season.',
  },
  {
    question: 'Are Chicago Sky games available on Fubo?',
    answer:
      'Yes, you can watch Chicago Sky games, as well as other Chicago home teams, on Marquee Sports Network with Fubo. Or you can subscribe to Fubo Pro to get Marquee Sports Network, ESPN and CBS Sports Network, and other sports channels to get even more live WNBA action without cable.',
  },
  {
    question: 'How do I find live MLB games on Fubo?',
    answer:
      'To find live MLB games on Fubo, simply navigate to the Sports section of the app or website. You can filter by MLB to see all the games currently being broadcast.',
  },
  {
    question: 'Where can I watch NFL commentary and analysis on Fubo?',
    answer:
      'You can find NFL commentary and analysis with Fubo on channels like ESPN and NFL Network. These networks offer pre-game shows, post-game analysis and expert commentary on the latest NFL news.',
  },
  {
    question: 'How can I access WNBA highlights and related shows on Fubo?',
    answer:
      'You can access WNBA highlights and related shows on Fubo by checking the Sports section or searching for WNBA content. This includes game recaps, analysis, and special features on the league.',
  },
  {
    question: 'Can I watch replays of Chicago Cubs games on Fubo?',
    answer:
      'Yes, you can watch replays of Chicago Cubs games on Marquee Sports Network with Fubo. After the live broadcast, games are often replayed at a later date or even available for on demand.',
  },
]
